import { MachinesApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useGetReportingStatisticsDevices = (userId: string) => {
  const [reportingStatisticsDevices] = useAPIAction(
    MachinesApi,
    async (api,) => {
      let response = await api.statisticsMachinesSearch({

      });
      console.log("RESPONSE of API is , ", (response))
      return {
        successMessages: [],
        data: response,
      };
    },
    {
      translationPrefix: "",
      defaultApiConfigOptions: {
        impersonationForId: userId,
      },
    },
  );
  return useCallback(async () => {
    return await reportingStatisticsDevices();
  }, [reportingStatisticsDevices]);
};
